import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../providers/AuthContext';
import { getAdminAuthHeaders } from '../../utils/adminApi';
import { getDisplayImageUrl } from '../../utils/imageUtils';
import { showConfirm, showError, showSuccess } from '../../utils/sweetAlert';
import EnhancedMediaLibrary from './EnhancedMediaLibrary';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const DEFAULT_BRAND = {
  logoUrl: '',
  heroImageUrl: '',
  primaryColor: '#1f8e38',
  backgroundColor: '#f8f9fa',
  footerText: 'Gracias por elegir REM Enterprises.',
  websiteUrl: '',
  instagramUrl: '',
  facebookUrl: '',
  tiktokUrl: ''
};

const EMPTY_CAMPAIGN = { name: '', subject: '', body: '', imageUrl: '', contentFormat: 'text' };
const REM_LOGO_URL = 'https://rementerprises.uy/images/remlogo.png';
const REM_IMAGO_URL = 'https://rementerprises.uy/images/ImagoR.png';
const REM_MAILING_HEADER = `<tr><td align="center" style="padding:0 0 24px"><img src="${REM_LOGO_URL}" alt="REM Enterprises" width="150" style="display:block;height:auto;margin:0 auto;max-width:150px;border:0"></td></tr>`;
const REM_MAILING_SIGNATURE = `<tr><td align="center" style="background:#1f8e38;border-radius:10px;padding:14px"><img src="${REM_IMAGO_URL}" alt="REM" width="42" height="42" style="display:block;height:42px;margin:0 auto;width:42px;border:0"></td></tr>`;
const CAMPAIGN_PRESETS = [
  {
    id: 'tienda',
    title: 'Novedades de la tienda',
    description: 'Presenta las categorías principales y dirige tráfico a la tienda.',
    eyebrow: 'Tráfico a tienda',
    icon: 'fa-bag-shopping',
    name: 'Novedades de la tienda',
    subject: 'Novedades para descubrir en REM Enterprises',
    contentFormat: 'html',
    body: `<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
  ${REM_MAILING_HEADER}
  <tr><td style="padding:0 0 8px"><p style="color:#1f8e38;font-size:12px;font-weight:700;letter-spacing:.12em;margin:0;text-transform:uppercase">Novedades de REM</p></td></tr>
  <tr><td style="padding:0 0 18px"><p style="margin:0;font-size:24px;line-height:1.25;font-weight:700;color:#171717">Tu próxima favorita puede estar acá.</p></td></tr>
  <tr><td style="padding:0 0 22px"><p style="margin:0;font-size:16px;line-height:1.6;color:#3f3f46">Hola {{nombre}},<br><br>Renovamos la tienda con diseños para usar, regalar y hacer tuyos. Elegí la categoría que más va con vos.</p></td></tr>
  <tr><td style="padding:0 0 14px"><img src="https://rementerprises.uy/images/categories/remeras.png" alt="Remeras originales" width="544" style="display:block;width:100%;height:auto;border:0;border-radius:10px"></td></tr>
  <tr><td align="center" style="padding:2px 0 22px"><a href="https://rementerprises.uy/tienda" style="background:#1f8e38;border-radius:8px;color:#ffffff;display:inline-block;font-weight:700;padding:13px 22px;text-decoration:none">Ver la tienda</a></td></tr>
  <tr><td style="background:#f0fdf4;border-radius:10px;padding:16px"><p style="color:#166534;font-size:14px;line-height:1.55;margin:0"><strong>Para todos los estilos.</strong> Encontrá remeras, canguros, cuadros, almohadones y más productos con la identidad de REM.</p></td></tr>
  <tr><td style="padding-top:20px">${REM_MAILING_SIGNATURE}</td></tr>
</table>`
  },
  {
    id: 'personalizados',
    title: 'Tu idea, personalizada',
    description: 'Invita a convertir una idea propia en un producto único.',
    eyebrow: 'Producto a medida',
    icon: 'fa-wand-magic-sparkles',
    name: 'Campaña personalizados',
    subject: 'Convertí tu idea en algo único',
    contentFormat: 'html',
    body: `<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
  ${REM_MAILING_HEADER}
  <tr><td style="padding:0 0 8px"><p style="color:#1f8e38;font-size:12px;font-weight:700;letter-spacing:.12em;margin:0;text-transform:uppercase">Diseñado por vos</p></td></tr>
  <tr><td style="padding:0 0 18px"><p style="margin:0;font-size:24px;line-height:1.25;font-weight:700;color:#171717">Una idea tuya merece salir del papel.</p></td></tr>
  <tr><td style="padding:0 0 22px"><p style="margin:0;font-size:16px;line-height:1.6;color:#3f3f46">Hola {{nombre}},<br><br>Elegí un producto, subí tu diseño y armá una pieza que sea realmente tuya. Nosotros nos encargamos de llevarla a la realidad.</p></td></tr>
  <tr><td style="padding:0 0 14px"><img src="https://rementerprises.uy/images/customization/tshirt-front-white-polyester.webp" alt="Producto personalizado REM" width="544" style="background:#f4f4f5;display:block;width:100%;height:auto;border:0;border-radius:10px"></td></tr>
  <tr><td align="center" style="padding:2px 0 22px"><a href="https://rementerprises.uy/personalizados" style="background:#1f8e38;border-radius:8px;color:#ffffff;display:inline-block;font-weight:700;padding:13px 22px;text-decoration:none">Crear mi personalizado</a></td></tr>
  <tr><td style="background:#f0fdf4;border-radius:10px;padding:16px"><p style="color:#166534;font-size:14px;line-height:1.55;margin:0"><strong>Una idea, muchas posibilidades.</strong> Ideal para regalar, representar a tu equipo o usar algo que nadie más tiene.</p></td></tr>
  <tr><td style="padding-top:20px">${REM_MAILING_SIGNATURE}</td></tr>
</table>`
  },
  {
    id: 'inspiracion',
    title: 'Inspiración REM',
    description: 'Una comunicación de marca para volver a conectar con la comunidad.',
    eyebrow: 'Conexión de marca',
    icon: 'fa-sparkles',
    name: 'Inspiración REM',
    subject: 'Diseños que hablan de vos',
    contentFormat: 'html',
    body: `<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
  ${REM_MAILING_HEADER}
  <tr><td style="padding:0 0 8px"><p style="color:#1f8e38;font-size:12px;font-weight:700;letter-spacing:.12em;margin:0;text-transform:uppercase">Inspiración REM</p></td></tr>
  <tr><td style="padding:0 0 18px"><p style="margin:0;font-size:24px;line-height:1.25;font-weight:700;color:#171717">No es solo lo que usás. Es lo que mostrás.</p></td></tr>
  <tr><td style="padding:0 0 22px"><p style="margin:0;font-size:16px;line-height:1.6;color:#3f3f46">Hola {{nombre}},<br><br>En REM creamos productos para quienes buscan expresar una idea, una pasión o una forma de ver el mundo. Pasá por la tienda y encontrá el diseño que te representa.</p></td></tr>
  <tr><td style="padding:0 0 14px"><img src="https://rementerprises.uy/images/categories/canguros.png" alt="Diseños REM Enterprises" width="544" style="display:block;width:100%;height:auto;border:0;border-radius:10px"></td></tr>
  <tr><td align="center" style="padding:2px 0 22px"><a href="https://rementerprises.uy/tienda" style="background:#1f8e38;border-radius:8px;color:#ffffff;display:inline-block;font-weight:700;padding:13px 22px;text-decoration:none">Explorar diseños</a></td></tr>
  <tr><td style="background:#f0fdf4;border-radius:10px;padding:16px"><p style="color:#166534;font-size:14px;line-height:1.55;margin:0">Una base de marca para volver a conectar con tu comunidad cuando lances una novedad o quieras mostrar una selección.</p></td></tr>
  <tr><td style="padding-top:20px">${REM_MAILING_SIGNATURE}</td></tr>
</table>`
  },
  {
    id: 'regalos',
    title: 'Regalos que cuentan algo',
    description: 'Una base cálida para fechas especiales, agradecimientos o regalos únicos.',
    eyebrow: 'Regalos y ocasiones',
    icon: 'fa-gift',
    name: 'Campaña regalos personalizados',
    subject: 'Un regalo pensado para esa persona especial',
    contentFormat: 'html',
    body: `<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
  ${REM_MAILING_HEADER}
  <tr><td style="padding:0 0 8px"><p style="color:#1f8e38;font-size:12px;font-weight:700;letter-spacing:.12em;margin:0;text-transform:uppercase">Regalos con identidad</p></td></tr>
  <tr><td style="padding:0 0 18px"><p style="margin:0;font-size:24px;line-height:1.25;font-weight:700;color:#171717">Regalá algo que tenga una historia.</p></td></tr>
  <tr><td style="padding:0 0 22px"><p style="margin:0;font-size:16px;line-height:1.6;color:#3f3f46">Hola {{nombre}},<br><br>Los mejores regalos no se eligen al azar. Creá una remera, almohadón o pieza personalizada con un mensaje, una foto o una idea que diga mucho más.</p></td></tr>
  <tr><td style="padding:0 0 14px"><img src="https://rementerprises.uy/images/categories/personalizados.png" alt="Regalos personalizados REM Enterprises" width="544" style="background:#f4f4f5;display:block;width:100%;height:auto;border:0;border-radius:10px"></td></tr>
  <tr><td align="center" style="padding:2px 0 22px"><a href="https://rementerprises.uy/personalizados" style="background:#1f8e38;border-radius:8px;color:#ffffff;display:inline-block;font-weight:700;padding:13px 22px;text-decoration:none">Pensar mi regalo</a></td></tr>
  <tr><td style="background:#f0fdf4;border-radius:10px;padding:16px"><p style="color:#166534;font-size:14px;line-height:1.5;margin:0"><strong>Una base lista para adaptar:</strong> cambiá el texto de esta campaña por la ocasión que quieras comunicar y conservá el diseño.</p></td></tr>
  <tr><td style="padding-top:20px">${REM_MAILING_SIGNATURE}</td></tr>
</table>`
  }
];
const TEMPLATE_INFO = {
  paymentApproved: {
    title: 'Pago aprobado',
    description: 'Se envía automáticamente cuando Mercado Pago confirma el pago.'
  },
  orderShipped: {
    title: 'Pedido enviado',
    description: 'Se envía automáticamente cuando cambias el estado de la orden a “Enviado”.'
  },
  orderReadyForPickup: {
    title: 'Pedido listo para retirar',
    description: 'Se envía automáticamente cuando un retiro en pickup cambia al estado “Terminado”.'
  }
};

const ImagePicker = ({ value, label, onSelect, onRemove }) => (
  <div className="emailmgr-image-picker">
    <span>{label}</span>
    {value ? <div className="emailmgr-image-thumb"><img src={getDisplayImageUrl(value)} alt={label} /><button type="button" onClick={onRemove} aria-label={`Quitar ${label}`}><i className="fas fa-times"></i></button></div> : <button type="button" className="emailmgr-image-empty" onClick={onSelect}><i className="fas fa-image"></i> Elegir imagen</button>}
    {value && <button type="button" className="emailmgr-change-image" onClick={onSelect}>Cambiar</button>}
  </div>
);

const EmailManager = () => {
  const { token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('transactional');
  const [templates, setTemplates] = useState(null);
  const [brand, setBrand] = useState(DEFAULT_BRAND);
  const [campaigns, setCampaigns] = useState([]);
  const [campaign, setCampaign] = useState(EMPTY_CAMPAIGN);
  const [editingCampaignId, setEditingCampaignId] = useState(null);
  const [subscriberCount, setSubscriberCount] = useState(0);
  const [testEmail, setTestEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mediaTarget, setMediaTarget] = useState(null);
  const [preview, setPreview] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  const headers = getAdminAuthHeaders(token, { 'Content-Type': 'application/json' });

  const loadData = async () => {
    try {
      setLoading(true);
      const [settingsResponse, campaignsResponse, statsResponse] = await Promise.all([
        fetch(`${API_BASE}/emails/settings`, { headers: getAdminAuthHeaders(token) }),
        fetch(`${API_BASE}/emails/campaigns`, { headers: getAdminAuthHeaders(token) }),
        fetch(`${API_BASE}/emails/subscribers/stats`, { headers: getAdminAuthHeaders(token) })
      ]);
      const [settingsData, campaignsData, statsData] = await Promise.all([
        settingsResponse.json(), campaignsResponse.json(), statsResponse.json()
      ]);

      if (!settingsResponse.ok) throw new Error(settingsData.error || 'No se pudieron cargar las plantillas');
      setTemplates(settingsData.transactional);
      setBrand({ ...DEFAULT_BRAND, ...(settingsData.brand || {}) });
      setCampaigns(campaignsResponse.ok ? campaignsData : []);
      setSubscriberCount(statsResponse.ok ? statsData.subscribers || 0 : 0);
    } catch (error) {
      showError(error.message || 'No se pudieron cargar los emails');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [token]);

  const updateTemplate = (templateKey, field, value) => {
    setTemplates(previous => ({ ...previous, [templateKey]: { ...previous[templateKey], [field]: value } }));
  };

  const updateBrand = (field, value) => setBrand(previous => ({ ...previous, [field]: value }));

  const saveTemplates = async () => {
    try {
      setSaving(true);
      const response = await fetch(`${API_BASE}/emails/settings`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ transactional: templates, brand })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudieron guardar las plantillas');
      setTemplates(data.transactional);
      setBrand({ ...DEFAULT_BRAND, ...(data.brand || {}) });
      showSuccess('Diseño y plantillas de email guardados');
    } catch (error) {
      showError(error.message || 'No se pudieron guardar las plantillas');
    } finally {
      setSaving(false);
    }
  };

  const generatePreview = async ({ subject, body, imageUrl, isCampaign = false, contentFormat = 'text' }) => {
    if (!subject.trim() || !body.trim()) {
      showError('Completa asunto y texto para generar la vista previa');
      return;
    }

    try {
      setPreviewLoading(true);
      const response = await fetch(`${API_BASE}/emails/preview`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ subject, body, imageUrl, brand, isCampaign, contentFormat })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo generar la vista previa');
      setPreview(data);
    } catch (error) {
      showError(error.message || 'No se pudo generar la vista previa');
    } finally {
      setPreviewLoading(false);
    }
  };

  const sendTransactionalTest = async (templateKey) => {
    if (!testEmail.trim()) return showError('Ingresa el email donde quieres recibir la prueba');

    try {
      const response = await fetch(`${API_BASE}/emails/transactional/test`, {
        method: 'POST', headers, body: JSON.stringify({ templateKey, to: testEmail.trim() })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo enviar la prueba');
      showSuccess('Email de prueba enviado');
    } catch (error) {
      showError(error.message || 'No se pudo enviar la prueba');
    }
  };

  const saveCampaign = async () => {
    try {
      setSaving(true);
      const response = await fetch(`${API_BASE}/emails/campaigns${editingCampaignId ? `/${editingCampaignId}` : ''}`, {
        method: editingCampaignId ? 'PUT' : 'POST', headers, body: JSON.stringify(campaign)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo guardar la campaña');
      setCampaigns(previous => editingCampaignId ? previous.map(item => item._id === data._id ? data : item) : [data, ...previous]);
      setCampaign({ ...EMPTY_CAMPAIGN });
      setEditingCampaignId(null);
      showSuccess(editingCampaignId ? 'Borrador actualizado' : 'Campaña guardada como borrador');
    } catch (error) {
      showError(error.message || 'No se pudo guardar la campaña');
    } finally {
      setSaving(false);
    }
  };

  const selectCampaign = (item) => {
    setEditingCampaignId(item._id);
    setCampaign({ name: item.name, subject: item.subject, body: item.body, imageUrl: item.imageUrl || '', contentFormat: item.contentFormat || 'text' });
  };

  const useCampaignPreset = (preset) => {
    setEditingCampaignId(null);
    setCampaign({
      name: preset.name,
      subject: preset.subject,
      body: preset.body,
      imageUrl: '',
      contentFormat: preset.contentFormat
    });
  };

  const previewCampaignPreset = (preset) => generatePreview({
    subject: preset.subject,
    body: preset.body,
    imageUrl: '',
    isCampaign: true,
    contentFormat: preset.contentFormat
  });

  const sendCampaignTest = async () => {
    if (!editingCampaignId) return showError('Guarda el borrador antes de enviar una prueba');
    if (!testEmail.trim()) return showError('Ingresa el email donde quieres recibir la prueba');

    try {
      const response = await fetch(`${API_BASE}/emails/campaigns/${editingCampaignId}/test`, {
        method: 'POST', headers, body: JSON.stringify({ to: testEmail.trim() })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo enviar la prueba');
      showSuccess('Prueba de campaña enviada');
    } catch (error) {
      showError(error.message || 'No se pudo enviar la prueba');
    }
  };

  const sendCampaign = async () => {
    if (!editingCampaignId) return showError('Guarda el borrador antes de enviar la campaña');

    const confirmation = await showConfirm(
      `La campaña se enviará a ${subscriberCount} suscriptor(es) que aceptaron recibir comunicaciones. Esta acción no se puede deshacer.`,
      'Enviar campaña'
    );
    if (!confirmation.isConfirmed) return;

    try {
      setSaving(true);
      const response = await fetch(`${API_BASE}/emails/campaigns/${editingCampaignId}/send`, {
        method: 'POST', headers, body: JSON.stringify({ confirmed: true })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo enviar la campaña');
      setCampaigns(previous => previous.map(item => item._id === data._id ? data : item));
      setCampaign({ ...EMPTY_CAMPAIGN });
      setEditingCampaignId(null);
      showSuccess('Campaña enviada a Resend');
    } catch (error) {
      showError(error.message || 'No se pudo enviar la campaña');
    } finally {
      setSaving(false);
    }
  };

  const handleMediaSelect = (media) => {
    const imageUrl = media.url || media.filename;
    if (!imageUrl || !mediaTarget) return;

    if (mediaTarget === 'brand-logo') updateBrand('logoUrl', imageUrl);
    if (mediaTarget === 'brand-hero') updateBrand('heroImageUrl', imageUrl);
    if (mediaTarget.startsWith('template-')) updateTemplate(mediaTarget.replace('template-', ''), 'imageUrl', imageUrl);
    if (mediaTarget === 'campaign') setCampaign(previous => ({ ...previous, imageUrl }));
  };

  if (loading) return <div className="emailmgr-loading"><i className="fas fa-spinner fa-spin"></i> Cargando emails...</div>;

  return (
    <div className="emailmgr-panel">
      <div className="emailmgr-header">
        <div><h1>Emails</h1><p>Diseña avisos de compra y campañas con la identidad de REM Enterprises.</p></div>
        <button type="button" onClick={loadData}><i className="fas fa-rotate"></i> Actualizar</button>
      </div>

      <div className="emailmgr-tabs">
        <button type="button" className={activeTab === 'transactional' ? 'active' : ''} onClick={() => setActiveTab('transactional')}><i className="fas fa-receipt"></i> Transaccionales</button>
        <button type="button" className={activeTab === 'campaigns' ? 'active' : ''} onClick={() => setActiveTab('campaigns')}><i className="fas fa-paper-plane"></i> Campañas <span>{subscriberCount}</span></button>
        <button type="button" className={activeTab === 'design' ? 'active' : ''} onClick={() => setActiveTab('design')}><i className="fas fa-palette"></i> Diseño y redes</button>
      </div>

      <div className="emailmgr-test-row"><label>Email de prueba<input type="email" value={testEmail} onChange={(event) => setTestEmail(event.target.value)} placeholder="tu@email.com" /></label><small>Este correo solo se usa para los botones de prueba.</small></div>

      {activeTab === 'design' && <section className="emailmgr-card emailmgr-brand-card">
        <div className="emailmgr-card-heading"><div><h2>Identidad visual</h2><p>Se aplica a todos los emails: encabezado, logo, fondo, pie y redes sociales.</p></div><button type="button" className="emailmgr-preview-btn" onClick={() => generatePreview({ subject: 'Vista previa de REM Enterprises', body: 'Hola {{nombre}},\n\nAsí se verán tus emails con la identidad visual configurada.', imageUrl: brand.heroImageUrl })}><i className="fas fa-eye"></i> Ver preview</button></div>
        <div className="emailmgr-brand-images"><ImagePicker label="Logo" value={brand.logoUrl} onSelect={() => setMediaTarget('brand-logo')} onRemove={() => updateBrand('logoUrl', '')} /><ImagePicker label="Imagen principal global" value={brand.heroImageUrl} onSelect={() => setMediaTarget('brand-hero')} onRemove={() => updateBrand('heroImageUrl', '')} /></div>
        <div className="emailmgr-brand-grid">
          <label>Color principal<input type="color" value={brand.primaryColor} onChange={(event) => updateBrand('primaryColor', event.target.value)} /></label>
          <label>Color de fondo<input type="color" value={brand.backgroundColor} onChange={(event) => updateBrand('backgroundColor', event.target.value)} /></label>
          <label className="emailmgr-brand-full">Texto del pie<textarea rows="2" value={brand.footerText} onChange={(event) => updateBrand('footerText', event.target.value)} /></label>
          <label>Sitio web<input type="url" value={brand.websiteUrl} onChange={(event) => updateBrand('websiteUrl', event.target.value)} placeholder="https://..." /></label>
          <label>Instagram<input type="url" value={brand.instagramUrl} onChange={(event) => updateBrand('instagramUrl', event.target.value)} placeholder="https://instagram.com/..." /></label>
          <label>Facebook<input type="url" value={brand.facebookUrl} onChange={(event) => updateBrand('facebookUrl', event.target.value)} placeholder="https://facebook.com/..." /></label>
          <label>TikTok<input type="url" value={brand.tiktokUrl} onChange={(event) => updateBrand('tiktokUrl', event.target.value)} placeholder="https://tiktok.com/@..." /></label>
        </div>
        <button type="button" className="emailmgr-primary-btn" onClick={saveTemplates} disabled={saving}><i className="fas fa-save"></i> Guardar diseño</button>
      </section>}

      {activeTab === 'transactional' && templates && <div className="emailmgr-template-list">
        {Object.entries(TEMPLATE_INFO).map(([templateKey, info]) => {
          const template = templates[templateKey];
          return <section key={templateKey} className="emailmgr-card">
            <div className="emailmgr-card-heading"><div><h2>{info.title}</h2><p>{info.description}</p></div><label className="emailmgr-switch"><input type="checkbox" checked={template.enabled} onChange={(event) => updateTemplate(templateKey, 'enabled', event.target.checked)} /><span></span> Activo</label></div>
            <ImagePicker label="Imagen exclusiva de este email" value={template.imageUrl} onSelect={() => setMediaTarget(`template-${templateKey}`)} onRemove={() => updateTemplate(templateKey, 'imageUrl', '')} />
            <label>Asunto<input value={template.subject} onChange={(event) => updateTemplate(templateKey, 'subject', event.target.value)} /></label>
            <label>Texto<textarea rows="6" value={template.body} onChange={(event) => updateTemplate(templateKey, 'body', event.target.value)} /></label>
            <div className="emailmgr-template-actions"><span>Variables: <code>{'{{nombre}}'}</code>, <code>{'{{numeroOrden}}'}</code>, <code>{'{{total}}'}</code>, <code>{'{{metodoEnvio}}'}</code>{templateKey === 'orderReadyForPickup' && <>, <code>{'{{pickupNombre}}'}</code>, <code>{'{{pickupCiudad}}'}</code>, <code>{'{{pickupDireccion}}'}</code>, <code>{'{{pickupIndicaciones}}'}</code>, <code>{'{{pickupTelefono}}'}</code></>}</span><div><button type="button" onClick={() => generatePreview({ subject: template.subject, body: template.body, imageUrl: template.imageUrl })}><i className="fas fa-eye"></i> Preview</button><button type="button" onClick={() => sendTransactionalTest(templateKey)}><i className="fas fa-flask"></i> Enviar prueba</button></div></div>
          </section>;
        })}
        <button type="button" className="emailmgr-primary-btn" onClick={saveTemplates} disabled={saving}><i className="fas fa-save"></i> Guardar plantillas y diseño</button>
      </div>}

      {activeTab === 'campaigns' && <div className="emailmgr-campaign-layout">
        <section className="emailmgr-card emailmgr-campaign-editor">
          <div className="emailmgr-card-heading"><div><h2>{editingCampaignId ? 'Editar borrador' : 'Nueva campaña'}</h2><p>Solo se envía a clientes que marcaron la suscripción durante el checkout.</p></div>{editingCampaignId && <button type="button" onClick={() => { setEditingCampaignId(null); setCampaign({ ...EMPTY_CAMPAIGN }); }}>Nuevo borrador</button>}</div>
          <div className="emailmgr-preset-section">
            <div className="emailmgr-preset-heading"><div><h3>Campañas HTML predefinidas <span>{CAMPAIGN_PRESETS.length} bases</span></h3><p>Diseños responsive, con logo REM, ImagoR, CTA y enlace de baja automático.</p></div><div className="emailmgr-preset-steps"><span>1. Elegí</span><i className="fas fa-arrow-right"></i><span>2. Editá</span><i className="fas fa-arrow-right"></i><span>3. Probá</span></div></div>
            <div className="emailmgr-preset-grid">{CAMPAIGN_PRESETS.map(preset => <article key={preset.id} className="emailmgr-preset-card"><div className="emailmgr-preset-icon"><i className={`fas ${preset.icon}`}></i></div><div><span><i className="fas fa-code"></i> HTML listo</span><strong>{preset.title}</strong><small>{preset.description}</small></div><p>{preset.eyebrow}</p><div className="emailmgr-preset-actions"><button type="button" onClick={() => previewCampaignPreset(preset)}><i className="fas fa-eye"></i> Ver preview</button><button type="button" className="emailmgr-preset-use" onClick={() => useCampaignPreset(preset)}>Usar base <i className="fas fa-arrow-right"></i></button></div></article>)}</div>
          </div>
          <ImagePicker label="Imagen exclusiva de esta campaña" value={campaign.imageUrl} onSelect={() => setMediaTarget('campaign')} onRemove={() => setCampaign(previous => ({ ...previous, imageUrl: '' }))} />
          <label>Nombre interno<input value={campaign.name} onChange={(event) => setCampaign(previous => ({ ...previous, name: event.target.value }))} placeholder="Ej: Lanzamiento canguros niños" /></label>
          <label>Asunto<input value={campaign.subject} onChange={(event) => setCampaign(previous => ({ ...previous, subject: event.target.value }))} placeholder="Nuevos canguros para niños" /></label>
          <fieldset className="emailmgr-content-format"><legend>Formato del contenido</legend><label><input type="radio" name="campaign-content-format" checked={campaign.contentFormat === 'text'} onChange={() => setCampaign(previous => ({ ...previous, contentFormat: 'text' }))} /> Texto simple</label><label><input type="radio" name="campaign-content-format" checked={campaign.contentFormat === 'html'} onChange={() => setCampaign(previous => ({ ...previous, contentFormat: 'html' }))} /> Código HTML</label></fieldset>
          <label>{campaign.contentFormat === 'html' ? 'Código HTML del mailing' : 'Texto'}<textarea className={campaign.contentFormat === 'html' ? 'emailmgr-html-editor' : ''} rows={campaign.contentFormat === 'html' ? '18' : '10'} value={campaign.body} onChange={(event) => setCampaign(previous => ({ ...previous, body: event.target.value }))} placeholder={campaign.contentFormat === 'html' ? '<table role="presentation">...</table>' : 'Hola {{nombre}},\n\nTenemos novedades...'} /></label>
          <p className="emailmgr-variable-note">{campaign.contentFormat === 'html' ? 'Podés pegar un mailing completo o un bloque HTML. Se eliminará contenido ejecutable y se conservará el diseño de email (tablas y estilos inline).' : 'Variables disponibles: '}<code>{'{{nombre}}'}</code> y <code>{'{{email}}'}</code>. Resend agregará el enlace de baja al envío final.</p>
          <div className="emailmgr-campaign-actions"><button type="button" onClick={saveCampaign} disabled={saving}><i className="fas fa-save"></i> Guardar borrador</button><button type="button" onClick={() => generatePreview({ subject: campaign.subject, body: campaign.body, imageUrl: campaign.imageUrl, isCampaign: true, contentFormat: campaign.contentFormat })}><i className="fas fa-eye"></i> Preview</button><button type="button" onClick={sendCampaignTest} disabled={saving || !editingCampaignId}><i className="fas fa-flask"></i> Enviar prueba</button><button type="button" className="emailmgr-send-btn" onClick={sendCampaign} disabled={saving || !editingCampaignId || subscriberCount === 0}><i className="fas fa-paper-plane"></i> Confirmar y enviar</button></div>
        </section>
        <section className="emailmgr-card emailmgr-campaign-history"><h2>Campañas</h2>{campaigns.length === 0 ? <p className="emailmgr-empty">No hay campañas creadas todavía.</p> : <div className="emailmgr-campaign-list">{campaigns.map(item => <button type="button" key={item._id} className={`emailmgr-campaign-item ${editingCampaignId === item._id ? 'active' : ''}`} onClick={() => item.status === 'draft' && selectCampaign(item)}><strong>{item.name}</strong><span>{item.status === 'sent' ? `Enviada a ${item.recipientCount}` : item.status === 'failed' ? 'Error al enviar' : 'Borrador'}</span><small>{item.subject}</small></button>)}</div>}</section>
      </div>}

      {preview && <section className="emailmgr-preview-overlay" onClick={() => setPreview(null)}><div className="emailmgr-preview-modal" onClick={(event) => event.stopPropagation()}><div className="emailmgr-preview-header"><div><h2>Vista previa</h2><p>{preview.subject}</p></div><button type="button" onClick={() => setPreview(null)}><i className="fas fa-times"></i></button></div>{previewLoading ? <div className="emailmgr-loading">Generando vista previa...</div> : <iframe sandbox="" title="Vista previa del email" srcDoc={`<!doctype html><html><body style="margin:0">${preview.html}</body></html>`} />}</div></section>}

      {mediaTarget && <div className="emailmgr-media-overlay" onClick={() => setMediaTarget(null)}><div className="emailmgr-media-modal" onClick={(event) => event.stopPropagation()}><div className="emailmgr-preview-header"><div><h2>Seleccionar imagen</h2><p>La imagen se guardará al presionar Guardar diseño o Guardar borrador.</p></div><button type="button" onClick={() => setMediaTarget(null)}><i className="fas fa-times"></i></button></div><EnhancedMediaLibrary mode="selection" onSelect={handleMediaSelect} /><button type="button" className="emailmgr-primary-btn" onClick={() => setMediaTarget(null)}>Listo</button></div></div>}
    </div>
  );
};

export default EmailManager;
